import { IMotivoProblema } from "../../../Interfaces/AssistenciaTecnica/MotivoProblema/MotivoProblemaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarMotivoProblemaService() {
    return Service(
        Axios.get<Array<IMotivoProblema>>(
            `/assistenciatecnica/motivoproblema/listarmotivosproblema`
        )
    );
}
export async function InserirMotivoProblemaService(
    requestBody: IMotivoProblema
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/motivoproblema/inserirmotivoproblema`,
            requestBody
        )
    );
}

export async function DeletarMotivoProblemaService(idMotivoProblema: number) {
    return Service(
        Axios.delete(
            `/assistenciatecnica/motivoproblema/excluirmotivoproblema?idMotivoProblema=${idMotivoProblema}`
        )
    );
}

export async function AtualizarMotivoProblemaService(
    requestBody: IMotivoProblema
) {
    return Service(
        Axios.put(
            `/assistenciatecnica/motivoproblema/atualizarmotivoproblema`,
            requestBody
        )
    );
}

export function ListarMotivoProblemaWebService() {
    return Service(
        Axios.get<Array<IMotivoProblema>>(
            `/assistenciatecnica/motivoproblema/listarmotivosproblemaweb`
        )
    );
}
